import { Injectable } from '@angular/core';
import { element } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  currentUser: any;
  user: any;
  constructor() { }

  getUserRole(data, type) {
    // console.log("what is the data type to send", data);

    this.user = JSON.parse(localStorage.getItem('userRoles'));
    // console.log("this.user...........", this.user);
    if (this.user.isAdmin || this.user.isLearner || this.user.isClient) {
      return this.user;
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // console.log("data.............", data);

    if (type === 'job' && this.currentUser != undefined) {
      let getRole = data.find(element => element._id === this.currentUser._id);
      if (getRole && getRole.role == 'IQA') {
        return { isIQA: true }
      } else if (getRole && getRole.role == 'trainer') {
        return { isTrainer: true }
      }
    }
  }

}
